import angular from 'angular';
import validate from './builder/validate.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/email/validate.html', validate);
});
